import { FormGroup } from '@angular/forms';
import { asEnumerable, AsEnumerable } from 'linq-es2015';
import { ResolvedSeedRequestsService } from '../../services/resolved-seed-requests.module';
var SeedRequestsComponent = /** @class */ (function () {
    function SeedRequestsComponent(seedRequestsService) {
        this.seedRequestsService = seedRequestsService;
        this.seedRequests = asEnumerable(seedRequestsService.seedRequests)
            .OrderByDescending(function (r) { return r.batchId; })
            .ToArray();
    }
    Object.defineProperty(SeedRequestsComponent.prototype, "anySeedRequests", {
        get: function () {
            return AsEnumerable(this.seedRequests).Any();
        },
        enumerable: true,
        configurable: true
    });
    return SeedRequestsComponent;
}());
export { SeedRequestsComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/seed-requests/seed-requests.component.ts.pre-build-optimizer.js